import { styled } from '@mui/system';
import theme from 'src/theme';
import breakpoint from 'src/theme/breakpoint';

export const LoaderWrapper = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh'
});

export const Container = styled('div')({
    background: theme.color.darkBlue
});

export const ChartHeader = styled('div')`
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 12px;

    @media (max-width: ${breakpoint.lg}) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const ChartTitleContainer = styled('div')({
    flex: 8
});

export const LegendsWrapper = styled('div')`
    color: ${theme.color.white};
    display: flex;
    flex-wrap: wrap;
    flex: 8;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    row-gap: 8px;

    @media (max-width: ${breakpoint.lg}) {
        justify-content: flex-start;
        margin-top: 8px;
    }
`;

export const LabelsRowContainer = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0px 20px'
});

export const LabelItem = styled('div')({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
});

export const descriptionStyle = {
    color: theme.color.white,
    fontFamily: 'Inter',
    fontSize: '12px',
    opacity: '0.5',
    width: '100%',
    display: 'block'
};

export const titleStyle = {
    flex: 1,
    color: theme.color.white,
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '16px'
};

export const totalStyle = {
    textAlign: 'right',
    width: '5%',
    color: theme.color.goldenColor,
    fontFamily: 'Inter',
    fontSize: '12px'
};

export const LabelStyle = {
    opacity: '0.3',
    fontSize: '11px',
    color: theme.color.white
};
